'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useSession } from '@src/hooks/useSession';
import { useUnlocalizedPathname } from '@src/hooks/useUnlocalizedPathname';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import type { TopNavItem, TopNavProps } from './TopNavProps';
interface TopNavContextType extends TopNavProps {
  expandedMenu: TopNavItem | null;
  setExpandedMenu: (menu: TopNavItem | null) => void;
  isExpanded: boolean;
  setExpanded: (isExpanded: boolean) => void;
  isMobileSubExpanded: boolean;
  setMobileSubExpanded: (isExpanded: boolean) => void;
  isAccountExpanded: boolean;
  setAccountExpanded: (isExpanded: boolean) => void;
}
export const TopNavContext = createContext<TopNavContextType>({
  expandedMenu: null,
  setExpandedMenu: () => {},
  isExpanded: false,
  setExpanded: () => {},
  isMobileSubExpanded: false,
  setMobileSubExpanded: () => {},
  isAccountExpanded: false,
  setAccountExpanded: () => {}
});
export const TopNavProvider = t0 => {
  const $ = _c(14);
  const {
    children,
    topNavProps
  } = t0;
  const {
    isComingFromLogin
  } = useSession();
  const pathname = useUnlocalizedPathname();
  const {
    isDesktop
  } = useBreakpoints();
  const [isExpanded, setExpanded] = useState(false);
  const [isMobileSubExpanded, setMobileSubExpanded] = useState(false);
  const [isAccountExpanded, setAccountExpanded] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);
  let t1;
  let t2;
  if ($[0] !== isComingFromLogin || $[1] !== isDesktop || $[2] !== pathname) {
    t1 = () => {
      const shouldExpandAccount = isDesktop && isComingFromLogin && !pathname.startsWith("/account") && !pathname.includes("/faq");
      setAccountExpanded(shouldExpandAccount);
    };
    t2 = [isComingFromLogin, pathname, isDesktop];
    $[0] = isComingFromLogin;
    $[1] = isDesktop;
    $[2] = pathname;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== expandedMenu || $[6] !== isAccountExpanded || $[7] !== isExpanded || $[8] !== isMobileSubExpanded || $[9] !== topNavProps) {
    t3 = {
      ...topNavProps,
      isExpanded,
      setExpanded,
      isMobileSubExpanded,
      setMobileSubExpanded,
      expandedMenu,
      setExpandedMenu,
      isAccountExpanded,
      setAccountExpanded
    };
    $[5] = expandedMenu;
    $[6] = isAccountExpanded;
    $[7] = isExpanded;
    $[8] = isMobileSubExpanded;
    $[9] = topNavProps;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const value = t3;
  let t4;
  if ($[11] !== children || $[12] !== value) {
    t4 = <TopNavContext.Provider value={value}>{children}</TopNavContext.Provider>;
    $[11] = children;
    $[12] = value;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export const useTopNav = () => {
  const context = useContext(TopNavContext);
  if (!context) {
    throw new Error("useTopNav must be used within a TopNavProvider");
  }
  return context;
};